import script from "./tutorList.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorList.vue?vue&type=script&setup=true&lang=js"

import "./tutorList.vue?vue&type=style&index=0&id=1ac524a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac524a0"]])

export default __exports__